import { useQuery } from '@tanstack/react-query'
import { deleteMusic } from '@/data/music/deleteMusic'
import { getMusic } from '@/data/music/getMusic'
import { queryKeys } from '@/lib/queryKeys'
import { GovUKResourceListPage } from '@/components/govuk'

export function MusicListPage() {
  const { data: musicList = [], isLoading } = useQuery({
    queryKey: queryKeys.music.lists(),
    queryFn: () => getMusic(),
  })

  return (
    <GovUKResourceListPage
      title="Music"
      caption="Your music collection"
      addRoute="/music/add"
      addButtonText="Add music"
      detailRoute={(id) => `/music/${id}`}
      items={musicList}
      isLoading={isLoading}
      queryKey={queryKeys.music.lists()}
      deleteFn={deleteMusic}
      renderItem={(music) => ({
        title: music.title,
        subtitle: `by ${music.artist}`,
      })}
    />
  )
}
